import { newAPI, basicAxios } from '../newAxios';
import axios from 'axios';

//Refresh Auth Api
export const refreshAuthToken = async () => {
    const response = await basicAxios.get('auth/refresh');
    return response.data;
};
export const loginUserAuthRequest = async (data) => {
    const result = await basicAxios.post('auth', data);
    return result.data;
};

export const logoutUserApi = async () => {
    const response = await basicAxios.get('auth/logout', {
        withCredentials: true
    });
    return response.data;
};
export const addNewUserAuthRequest = async () => {
    const res = await newAPI.get(`user/${11}`);
    return res.data[0];
};
///Get Company details
export const getMyCompanyData = async () => {
    try {
        const respo = await axios.get(process.env.REACT_APP_GET_COMPANY_DATA_URL, {
            headers: {
                authorization: `Bearer ${process.env.REACT_APP_HEADER}`
            }
        });

        const returnData = {
            company_code: respo.data.company_code ?? 1,
            company_name: respo.data.customer_name ?? 'Acetech India'
        };
        return returnData;
    } catch (error) {
        const errData = error?.response?.data || {};
        const returnData = {
            company_code: errData.company_code ?? 1,
            company_name: errData.customer_name ?? 'Acetech India'
        };
        return returnData;
    }
};

export const updateEmployeeLogin = async (payload) => {
    const { data, id } = payload;
    const res = await newAPI.patch(`user/${id}`, data);
    return res.data;
};

export const updateUserRoleApi = async (payload) => {
    const { role_id, userId } = payload;
    const res = await newAPI.put(`user/${userId}`, { role_id: role_id });
    return res.data;
};
